import ElectricBolt from "@mui/icons-material/ElectricBolt";
import { Divider, IconButton, Tooltip } from "@mui/material";
import { useCallback, useState } from "react";
import { floatingToolbarStyles } from "../toolbar/floating-toolbar-styles";
import { useCoPilotToolbarContext } from "./co-pilot-toolbar-context";
import { useLexicalSelection } from "./use-lexical-selection";

import type { ChannelName } from "../../../../channels/types";
import type { FC, MouseEvent } from "react";

export const CoPilotToolbarButton: FC<{
  channel: NonNullable<ChannelName>;
  format: "email" | "chat" | "sms";
  disabled?: boolean;
}> = ({ channel, format, disabled }) => {
  const selection = useLexicalSelection();
  const { openPanel } = useCoPilotToolbarContext();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      setOpen(false);
      const rect = e.currentTarget.getBoundingClientRect();
      openPanel({
        anchorPosition: { top: rect.bottom, left: rect.left },
        capturedSelection: selection,
        channel,
        format,
      });
    },
    [selection, channel, format, openPanel],
  );

  return (
    <>
      {/* Hide divider for SMS format, because we only show the CoPilot button */}
      {format !== "sms" && <Divider orientation="vertical" flexItem />}
      <Tooltip
        title="CoPilot"
        disableFocusListener
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <IconButton
          data-analytics-id="lexical-co-pilot-floating-toolbar-button"
          tabIndex={-1}
          disabled={disabled}
          onClick={handleClick}
          sx={floatingToolbarStyles.floating.button}
        >
          <ElectricBolt sx={floatingToolbarStyles.floating.formatIcon} />
        </IconButton>
      </Tooltip>
    </>
  );
};
